import { FC } from "react";
import { Box, TextField, Typography, Stack } from "@mui/material";

interface AdvanceFormProps {
    documentDate: string;
    paymentTerm: number;
    setPaymentTerm: (term: number) => void;
    advanceAmount: number;
    setAdvanceAmount: (amount: number) => void;
}

function addDays(dateStr: string, days: number) {
    const date = new Date(dateStr);
    date.setDate(date.getDate() + days);
    return date.toISOString().slice(0, 10);
}

const AdvanceForm: FC<AdvanceFormProps> = ({
    documentDate,
    paymentTerm,
    setPaymentTerm,
    advanceAmount,
    setAdvanceAmount,
}) => {
    const paymentDate = addDays(documentDate, paymentTerm);

    const handleTermChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let term = Number(e.target.value);
        term = Math.max(1, Math.min(term, 100)); // ograniczenie do 1-100
        setPaymentTerm(term);
    };

    const handleAdvanceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = Math.max(0, Number(e.target.value));
        setAdvanceAmount(value);
    };

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "1102px",
                mx: "auto",
                mt: 2,
                mb: 2,
                background: "#fff",
                borderRadius: 2,
                boxShadow: 5,
                p: 3,
            }}
        >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, textAlign: "center" }}>
                Płatność
            </Typography>
            <Stack spacing={2}>
                <TextField
                    label="Termin płatności [dni]"
                    type="number"
                    value={paymentTerm}
                    onChange={handleTermChange}
                    variant="outlined"
                    inputProps={{ style: { textAlign: "center" } }}
                    fullWidth
                />
                <TextField
                    label="Kwota zaliczki [PLN]"
                    type="number"
                    value={advanceAmount}
                    onChange={handleAdvanceChange}
                    variant="outlined"
                    inputProps={{ min: 0, step: 0.01, style: { textAlign: "center" } }}
                    fullWidth
                />
            </Stack>
            <Typography sx={{ mt: 2, textAlign: "center", color: "#888" }}>
                Data dokumentu: <b>{documentDate}</b>
            </Typography>
            <Typography sx={{ mt: 2, textAlign: "center", color: "#888" }}>
                Data płatności: <b>{paymentDate}</b>
            </Typography>
        </Box>
    );
};

export default AdvanceForm;